import { Action, Selector, State, StateContext, Store } from '@ngxs/store';
import { IChangeRequest, IChangeRequestApprovalRes } from './interface';
import { inject, Injectable } from '@angular/core';
import { ChangeRequetService } from './change-requests.service';
import {
    CreateChangeRequest,
    GetAllRequests,
    GetApproverRequests,
    GetByUser,
    GetChangeRequestApprovers,
    GetSingleChangeRequest
} from './action';
import { catchError, tap } from 'rxjs';

export class IProps {
    changeRequests!: IChangeRequest[];
    approvalRes!: IChangeRequestApprovalRes[];
    changeRequest!: IChangeRequest | null;

    loadingSingle!: boolean;
    loading!: boolean;
    error!: string | null;
}

@State<IProps>({
    name: 'changeRequests',
    defaults: {
        changeRequests: [],
        changeRequest: null,
        approvalRes: [],
        loadingSingle: false,
        loading: false,
        error: null
    }
})
@Injectable()
export class ChangeRequestsState {
    requestsService: ChangeRequetService = inject(ChangeRequetService);
    private store: Store = inject(Store);

    @Selector()
    static getRequests(state: IProps) {
        return state.changeRequests;
    }
    @Selector()
    static getApprovalRequests(state: IProps) {
        return state.approvalRes;
    }
    @Selector()
    static singleRequest(state: IProps) {
        return state.changeRequest;
    }

    @Selector()
    static getUserRequests(state: IProps) {
        return state.changeRequests;
    }

    @Selector()
    static loading(state: IProps) {
        return state.loading;
    }

    @Action(GetAllRequests)
    getAllRequest(ctx: StateContext<IProps>, action: GetAllRequests) {
        const state = ctx.getState();
        ctx.patchState({ loading: true });

        return this.requestsService.getRequests(action.queryParams as any).pipe(
            tap((res) => {
                ctx.patchState({
                    changeRequests: res,
                    loading: false,
                    error: null
                });
            }),
            catchError((err) => {
                ctx.patchState({
                    loading: false,
                    error: err.message
                });
                throw err;
            })
        );
    }

    @Action(CreateChangeRequest)
    createChangeRqst(ctx: StateContext<IProps>, action: CreateChangeRequest) {
        const state = ctx.getState();
        ctx.patchState({ loading: true });

        return this.requestsService.createChangeRequest(action.input).pipe(
            tap((res) => {
                ctx.patchState({
                    changeRequests: [...state.changeRequests, res],
                    changeRequest: res,

                    loading: false
                });
            }),
            catchError((err) => {
                ctx.patchState({
                    error: err.message,
                    loading: false
                });
                throw err;
            })
        );
    }

    @Action(GetSingleChangeRequest)
    getOneRequest(ctx: StateContext<IProps>, action: GetSingleChangeRequest) {
        const state = ctx.getState();
        ctx.patchState({ loadingSingle: true });

        return this.requestsService.getSingle(action.id).pipe(
            tap((res) => {
                ctx.patchState({
                    changeRequest: res,
                    loadingSingle: false
                });
            }),
            catchError((err) => {
                ctx.patchState({
                    loadingSingle: false,
                    error: err.message
                });
                throw err;
            })
        );
    }

    @Action(GetByUser)
    getByUser(ctx: StateContext<IProps>, action: GetByUser) {
        const state = ctx.getState();
        ctx.patchState({ loading: true });

        return this.requestsService.getByUser(action.input).pipe(
            tap((res) => {
                ctx.patchState({
                    changeRequests: res,
                    loading: false
                });
            }),
            catchError((err) => {
                ctx.patchState({
                    loading: false,
                    error: err.message
                });
                throw err;
            })
        );
    }

    @Action(GetApproverRequests)
    getByApprovers(ctx: StateContext<IProps>, action: GetApproverRequests) {
        const state = ctx.getState();
        ctx.patchState({ loading: true });

        return this.requestsService.getApproverRequests(action.input).pipe(
            tap((res: IChangeRequestApprovalRes[]) => {
                ctx.patchState({
                    approvalRes: res,
                    loading: false
                });
            }),
            catchError((err) => {
                ctx.patchState({
                    loading: false,
                    error: err.message
                });
                throw err;
            })
        );
    }

    @Action(GetChangeRequestApprovers)
    getRequestByApprovers(ctx: StateContext<IProps>, action: GetChangeRequestApprovers) {
        const state = ctx.getState();
        ctx.patchState({ loading: true });

        return this.requestsService.getApproverRequests(action.input).pipe(
            tap((res: IChangeRequestApprovalRes[]) => {
                ctx.patchState({
                    approvalRes: res,
                    loading: false
                });
            }),
            catchError((err) => {
                ctx.patchState({
                    loading: false,
                    error: err.message
                });
                throw err;
            })
        );
    }
    // @Action(AddRequestComment)
    // addComment(ctx: StateContext<IProps>, action: AddRequestComment) {
    //     const state = ctx.getState();
    //     ctx.patchState({ loading: true });

    //     return this.requestsService.comment(action.input).pipe(
    //         tap((res) => {
    //             ctx.patchState({
    //                 // requests: state.requests?.map((r)=>r.id===action.input.remarkId?{...r,...action.input as any}:r) ,
    //                 loading: false
    //             });
    //         }),
    //         catchError((err) => {
    //             ctx.patchState({
    //                 loading: false,
    //                 error: err.message
    //             });
    //             throw err;
    //         })
    //     );
    // }
}
